import workspaceQuery from '../../../graphql/queries/sales/AcknowledgementWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/AcknowledgementListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/AcknowledgementQuery.graphql';
import fragment from '../../../graphql/fragments/sales/AcknowledgementFragment.graphql';

import generateMutation from '../../../graphql/mutations/sales/AcknowledgementGenerateMutation.graphql';
import generateRangeMutation from '../../../graphql/mutations/sales/AcknowledgementGenerateRangeMutation.graphql';
import reprintMutation from '../../../graphql/mutations/sales/AcknowledgementReprintMutation.graphql';

import * as printFunctions from '../../../actions/sales/AcknowledgementAction';
import { salesDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const Acknowledgement: EntityType = {
  type: 'Acknowledgement',
  title: 'Acknowledgement',
  formUrl: '/Sales/Acknowledgements/Form/',
  formTitle: 'Print Acknowledgements',
  workspaceUrl: '/Sales/Acknowledgements/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  generate: generateMutation,
  generateRange: generateRangeMutation,
  reprint: reprintMutation,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentSuffix',
  },
  fragment,
  printFunctions: printFunctions,
  screenReference: 'SALES_DOCUMENTS_PRINT_ACKNOWLEDGEMENTS',
  configuration: {
    title: 'Acknowledgements',
    field: 'acknowledgementDefault',
    reportType: ReportType.SalesAcknowledgement,
    customerField: 'customerAcknowledgementDefault',
    receiveFlag: 'receiveAcknowledgements',
  },
  operations: 0,
  mergeFields: salesDocument,
};

export default Acknowledgement;
